import axios from "axios";
import { setIsAuthenticated } from "../redux/reducers/authSlice";
import { setUserData } from "../redux/reducers/masterDataSlice";
import { setPageUrl } from "../redux/reducers/authSlice";
// The one backend URL (dev/prod flip lives only in services.js). Plain axios, not the
// shared `api` instance: its 401 handler calls performLogout.
import { newBaseUrl } from "../api/services";

export function performLogout(dispatch) {
    // Best-effort server-side logout audit log
    try {
        axios.post(newBaseUrl + "api/authentication/logout", {}).catch(() => {});
    } catch (_) {}

    dispatch(setIsAuthenticated(false));
    dispatch(setUserData([]));
    dispatch(setPageUrl("/"));
    window.localStorage.removeItem("sessionToken");
    window.localStorage.removeItem("accessToken");
    window.localStorage.removeItem("refreshToken");
    setTimeout(() => { window.location.href = "/"; }, 100);
}
